import SectionHeading from "@/components/base/SectionHeading";
import { aboutImage, aboutImageAlt, principles, site, testimonials } from "@/mocks/site";

export default function BrandSection() {
  return (
    <section className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="ABOUT US"
        title="我们怎么整理每一条大瓜"
        description="网红大瓜不是一个跟风转发的搬运号，而是一个把碎片信息重新拼回完整事件的整理者。"
      />

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-5">
          <div className="relative h-64 w-full overflow-hidden rounded-lg bg-background-100 md:h-80 lg:h-full lg:min-h-[380px]">
            <img
              src={aboutImage}
              alt={aboutImageAlt}
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="mb-6 text-sm leading-relaxed text-foreground-700 md:text-base">
            {site.name}始于 {site.since} 年，最初只是几个人把看到的大瓜链接丢进同一个收藏夹。后来我们发现，
            真正让人头疼的不是瓜太少，而是信息太碎：原帖删了、截图糊了、说法互相打架。
            于是我们开始做一件事——把每一条爆料重新排好顺序，补齐原帖与回应，让它变回一件能被看懂的事。
          </p>

          <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <h3 className="mb-1.5 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-chat-quote-line text-primary-500" />
              瓜友怎么说
            </h3>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="rounded-md border border-background-200 bg-background-50 p-4"
                >
                  <blockquote className="mb-3 text-sm leading-relaxed text-foreground-700">
                    “{item.quote}”
                  </blockquote>
                  <figcaption className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-user-3-line text-xs" />
                    </span>
                    <span className="font-medium text-foreground-800">{item.name}</span>
                    <span>· {item.role}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}